import styled from 'styled-components';
import { Box } from 'edenred-ui';

export const StepCircle = styled(Box)`
  width: 32px;
  height: 32px;
  aspect-ratio: 1 / 1;
  border-radius: 50%;
  background-color: ${({ color }) => color};
  color: ${props => props.theme.primaryBackgroundColor};
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: ${({ theme }) => theme.fontSemiBold};
  font-size: ${props => props.theme.sizeMedium};
`;
